module.exports = __webpack_public_path__ + "static/green-yoga-0ea29640f66348037359c40044720124.mp4";